import { useApiPaginated } from "@/hooks/useApiPaginated";
import type { Member } from "@/hooks/useMembers";
import { queryKeys } from "@/lib/queryKeys";

export function useMembersPaginated(page: number, pageSize: number, q = "") {
  const { data, total, counts, loading, error, refetch } = useApiPaginated<Member>(
    queryKeys.members.paginated({ page, pageSize, q }),
    "/api/v2/members",
    page,
    pageSize,
    { q },
    "Failed to load members",
    ["X-Active-Count", "X-Pending-Count"],
  );
  return {
    members: data,
    total,
    activeCount: counts["X-Active-Count"] ?? 0,
    pendingCount: counts["X-Pending-Count"] ?? 0,
    loading,
    error,
    refetch,
  };
}
